import React, {PureComponent} from "react";
import {Image, Modal} from "react-bootstrap";
import publicityImage from './../../assets/images/publicity/publicity.jpg';

export default class PublicityModal extends PureComponent {
    render() {
        const {isPublicityShow, hidePublicity} = this.props;
        return (
            <Modal show={isPublicityShow} size='lg' onHide={hidePublicity}>
                <Modal.Header closeButton/>
                <Modal.Body>
                    <Image src={publicityImage}/>
                </Modal.Body>
            </Modal>
        )
    }
}
